// 泳池配置常量
export const poolConfig = {
  // 默认尺寸
  defaultWidth: 120,
  defaultHeight: 120,
  // 标题区域
  titleSize: 60,
  poolMinSize: 20,
}

export const laneConfig = {
  defaultWidth: 120,
  defaultHeight: 120,
  titleSize: 20,
  iconSize: 20,
  iconSpacing: 15,
}

export default null
